import { Tabs, Tab } from '@mui/material';
import { withStyles } from '@mui/styles';
import { theme } from 'config';

export const StyledTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
})(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    marginRight: '15px',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:selected': {
      color: theme.palette.primary.main,
      // fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
    },
  },
  selected: {
    color: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamilyBold,
  },
}))((props) => <Tab disableRipple {...props} />);
